export default __webpack_public_path__ + "static/media/cake.1cf6f49e.svg";